'use strict';

define('FormElements',[
  'FieldsetView',
  'SelectView',
  'TextFieldView',
  'MarkupView',
  'PaymentInformationView',
  'ContributionView',
  'NotMeView',
  'CaptchaView',
  'TrackingPixelView',
  'TicketingView',
  'HiddenView',
  'AdvocacyView',
  'AdvocacyTweetsView',
  'TributeGiftView',
  'RecipientInformationView',
  'ActivistCodeQuestionView',
  'ShippingInformationView',
  'EventInformationView',
  'TimeView',
  'InternationalPhoneView',
  'SignaturePadView',
  'PaymentMethodView'
], function (FieldsetView, SelectView, TextFieldView, MarkupView, PaymentInformationView, ContributionView, NotMeView,
             CaptchaView, TrackingPixelView, TicketingView, HiddenView, AdvocacyView, AdvocacyTweetsView,
             TributeGiftView, RecipientInformationView, ActivistCodeQuestionView, ShippingInformationView,
             EventInformationView, TimeView, InternationalPhoneView, SignaturePadView, PaymentMethodView) {
  return {
    'fieldset_view': FieldsetView,
    'select_view': SelectView,
    'textfield_view': TextFieldView,
    'markup_view': MarkupView,
    'payment_information_view': PaymentInformationView,
    'contribution_view': ContributionView,
    'notme_view': NotMeView,
    'captcha_view': CaptchaView,
    'trackingpixel_view': TrackingPixelView,
    'ticketing_view': TicketingView,
    'hidden_view': HiddenView,
    'advocacy_view': AdvocacyView,
    'advocacy_tweets_view': AdvocacyTweetsView,
    'tribute_gift_view': TributeGiftView,
    'recipient_information_view': RecipientInformationView,
    'activistCodeQuestion_view': ActivistCodeQuestionView,
    'shipping_information_view': ShippingInformationView,
    'event_information_view' : EventInformationView,
    'time_view': TimeView,
    'international_phone_view': InternationalPhoneView,
    'signature_pad_view': SignaturePadView,
    'payment_method_view': PaymentMethodView
  };
});

